import { XStack, YStack } from 'tamagui';

import {
    Button,
    ButtonSize,
    ButtonVariant,
} from '../../components/buttons/Button';
import { LoadingSkeleton } from '../../components/loading/Skeleton';
import { SpinnerIcon } from '../../components/spinners/SpinnerIcon';
import { Spinner, SpinnerSize } from '../../components/spinners/Spinners';
import {
    BodyLargeEmphasized,
    BodySmallRegular,
    LabelEmphasized,
    LabelRegular,
} from '../../components/text/Typography';

export const WaitingAndLoading = () => {
    return (
        <YStack gap={16} width="100%">
            <BodyLargeEmphasized>Spinners</BodyLargeEmphasized>
            <BodySmallRegular>
                We currently only have one size of Spinner, which an be used
                inline as a child component, or the component can return the
                FullScreenSpinner. The inline Spinner extends View, so you can
                provide view props for padding, margin, height, etc.
            </BodySmallRegular>
            <YStack alignItems="center">
                <LabelEmphasized>Spinner (default)</LabelEmphasized>
                <Spinner paddingTop={16} />
            </YStack>
            <YStack alignItems="center">
                <LabelEmphasized textAlign="center">
                    Spinner (size small)
                </LabelEmphasized>
                <LabelRegular textAlign="center">
                    Inline or FullScreenSpinner
                </LabelRegular>
                <Spinner size={SpinnerSize.SMALL} paddingTop={8} />
            </YStack>
            <BodyLargeEmphasized marginTop={16}>
                SpinnerIcon
            </BodyLargeEmphasized>
            <BodySmallRegular>
                A small inline rotating loader icon, intended to replace the
                leading icon of a button while an action is pending (e.g.
                &quot;Saving&quot; or &quot;Deleting&quot;).
            </BodySmallRegular>
            <XStack alignItems="center" gap={16}>
                <SpinnerIcon />
                <SpinnerIcon size={20} color="$red900" />
                <SpinnerIcon size={24} color="$green900" durationMs={1500} />
            </XStack>
            <XStack alignItems="center" gap={12}>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.SMALL}
                    text="Saving"
                    icon={<SpinnerIcon />}
                    iconPosition="left"
                    disabled
                    width="auto"
                />
                <Button
                    variant={ButtonVariant.TERTIARY}
                    size={ButtonSize.SMALL}
                    tone="danger"
                    text="Deleting"
                    icon={<SpinnerIcon />}
                    iconPosition="left"
                    disabled
                    width="auto"
                />
            </XStack>
            <BodyLargeEmphasized marginTop={16}>
                LoadingSkeleton
            </BodyLargeEmphasized>
            <BodySmallRegular>
                We also have a few uses of a &quot;Loading Skeleton&quot;
                component, used to draw a template of the UI that is loading.
                Appropriate to use when there is enough information to know what
                skeleton UI to draw but would not want to fill it with multiple
                spinners or have a giant white block with just one small spinner
                in it.
            </BodySmallRegular>
            <BodySmallRegular>
                You can pass any view props to the component to shape it like
                the content.
            </BodySmallRegular>
            <XStack gap={16}>
                <LoadingSkeleton height={30} width={30} borderRadius={100} />
                <LoadingSkeleton height={30} width={100} borderRadius={50} />
                <LoadingSkeleton height={30} width={150} />
            </XStack>
        </YStack>
    );
};
